export default __webpack_public_path__ + "static/media/dancing.5f4cbfb4.gif";